import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  InfoDataTable,
  ModalComponentWrapper,
  ResultContent,
} from '@/shared/components';
import { cn } from '@/shared/utils';
import type { WithdrawCommissionData } from '@/shared/types';
import type { ReactNode } from 'react';

interface ResultModalProps {
  success: boolean;
  data: {
    commissionData: WithdrawCommissionData;
    platform: ReactNode;
    fls: string;
  };
  onClose: () => void;
}

export function ResultModal({ success, data, onClose }: ResultModalProps) {
  const { t } = useTranslation();

  const title = success ? t('common.readyTitle') : t('common.errorTitle');
  const description = success
    ? t('withdrawMethods.crypto.result.successDescription')
    : t('withdrawMethods.crypto.result.tryAgain');
  const closeBtnText = success ? t('common.doneButton') : t('common.close');

  const tableData = [
    {
      key: t('withdrawMethods.sccrs.placeholders.platform'),
      value: data.platform,
    },
    {
      key: t('withdrawMethods.crypto.result.totalWithdraw'),
      value: data.commissionData.totalWithdrawAmountStr,
    },
    {
      key: t('withdrawMethods.crypto.result.withdrawFee'),
      value: data.commissionData.feeStr,
    },
    {
      key: t('withdrawMethods.sccrs.placeholders.fls'),
      value: data.fls,
    },
  ];

  return (
    <ModalComponentWrapper
      footer={
        <Button
          type="submit"
          variant="default"
          size="lg"
          onClick={onClose}
          className={cn('w-full')}>
          {closeBtnText}
        </Button>
      }>
      <ResultContent
        className="h-auto"
        isSuccess={success}
        showButton={false}
        title={title}
        description={description}>
        {success && (
          <Card variant="details" className="w-full">
            {success && <InfoDataTable data={tableData} className="p-0" />}
          </Card>
        )}
      </ResultContent>
    </ModalComponentWrapper>
  );
}
